// extracted by mini-css-extract-plugin
module.exports = {"Loader":"loader-module--Loader--15JHA","loader":"loader-module--loader--1GpXo","Loader__logo":"loader-module--Loader__logo--3v50F"};